import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    username: '',
    name: '',
    userType: null // 添加userType状态
  },
  mutations: {
    setToken (state, token) {
      state.token = token
    },
    setUsername (state, username) {
      state.username = username
    },
    setName (state, name) {
      state.name = name
    },
    setUserType (state, userType) {
      state.userType = userType
    },
    clearUser (state) {
      state.token = ''
      state.username = ''
      state.name = ''
      state.userType = null
    }
  },
  actions: {
    login ({ commit }, { token, username, name, userType }) {
      commit('setToken', token)
      commit('setUsername', username)
      commit('setName', name)
      commit('setUserType', userType) // 添加userType到store
    },
    logout ({ commit }) {
      commit('clearUser')
    }
  },
  getters: {
    displayName: (state) => state.name || state.username || '管理员',
    currentUserType: (state) => state.userType // 添加获取当前用户类型的getter
  },
  plugins: [
    createPersistedState({
      key: 'voting-manage',
      paths: ['token', 'username', 'name', 'userType'] // 在持久化中包含userType
    })
  ]
})
